import React from "react";
import { BsLadder } from "react-icons/bs";

export const SingleElim = ({ type, width, height, color, style }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="10 0 76 70"
      version="1.1"
      baseProfile="full"
      style={style}
    >
      <path
        fill={color}
        d={
          "M 23.75,60.1667L 23.75,53.8333L 31.6667,53.8333L 31.6666,47.5L 23.75,47.5L 23.75,41.1667L 38,41.1667L 38,47.5L 44.3333,47.5L 44.3333,28.5L 38,28.5L 38,34.8333L 23.75,34.8333L 23.75,28.5L 31.6667,28.5L 31.6666,22.1666L 23.75,22.1667L 23.75,15.8333L 38,15.8333L 38,22.1666L 50.6666,22.1667L 50.6666,34.8333L 58.5833,34.8333L 58.5833,41.1667L 50.6666,41.1667L 50.6666,53.8333L 38,53.8333L 38,60.1667L 23.75,60.1667 Z "
        }
      />
    </svg>
  );
};

export const DoubleElim = ({ type, width, height, color, style }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="10 0 76 76"
      version="1.1"
      baseProfile="full"
      enable-background="new 0 0 50.00 76.00"
      style={style}
    >
      <path
        fill={color}
        stroke-width="0.2"
        stroke-linejoin="round"
        d="M 17.4167,58.5833L 17.4167,53.8333L 22.1667,53.8333L 22.1667,45.9167L 17.4167,45.9167L 17.4167,41.1667L 26.9167,41.1667L 26.9167,47.5L 30.0833,47.5L 30.0833,28.5L 26.9167,28.5L 26.9167,34.8333L 17.4167,34.8334L 17.4167,30.0833L 22.1667,30.0833L 22.1667,22.1667L 17.4167,22.1667L 17.4167,17.4167L 26.9167,17.4167L 26.9167,23.75L 34.8333,23.75L 34.8333,34.8333L 41.1667,34.8333L 41.1667,23.75L 49.0833,23.75L 49.0833,17.4167L 58.5833,17.4167L 58.5833,22.1667L 53.8333,22.1667L 53.8333,30.0833L 58.5833,30.0833L 58.5833,34.8333L 49.0833,34.8333L 49.0833,28.5L 45.9167,28.5L 45.9167,47.5L 49.0833,47.5L 49.0833,41.1667L 58.5833,41.1666L 58.5833,45.9167L 53.8333,45.9167L 53.8333,53.8333L 58.5833,53.8333L 58.5833,58.5833L 49.0833,58.5833L 49.0833,52.25L 41.1667,52.25L 41.1667,41.1667L 34.8333,41.1667L 34.8333,52.25L 26.9167,52.25L 26.9167,58.5833L 17.4167,58.5833 Z "
      />
    </svg>
  );
};
export const RoundRobin = ({ type, width, height, color, style }) => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      viewBox="0 0 487.675 487.675"
      width={width}
      height={height}
      style={style}
    >
      <g>
        <g>
          <path
            fill={color}
            stroke-width="0.2"
            stroke-linejoin="round"
            d="M99.687,407.875h-33.6c-13.7,0-24.9-11.2-24.9-24.9v-278.4c0-13.7,11.2-24.9,24.9-24.9h227.3l-29.6,29.6
			c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.5,0,6.9-1.3,9.5-4l52.7-52.7c2.5-2.5,4-6,4-9.5c0-3.5-1.4-7-4-9.5l-52.7-52.7
			c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1l29.6,29.6h-227.2c-28.6,0-51.9,23.3-51.9,51.9v278.5
			c0,28.6,23.3,51.9,51.9,51.9h33.7c7.5,0,13.5-6,13.5-13.5S107.187,407.875,99.687,407.875z"
          />
          <path
            fill={color}
            stroke-width="0.2"
            stroke-linejoin="round"
            d="M421.687,52.675h-33.7c-7.5,0-13.5,6-13.5,13.5s6,13.5,13.5,13.5h33.7c13.7,0,24.9,11.2,24.9,24.9v278.5
			c0,13.7-11.2,24.9-24.9,24.9h-227.3l29.6-29.6c5.3-5.3,5.3-13.8,0-19.1c-5.3-5.3-13.8-5.3-19.1,0l-52.7,52.7c-2.5,2.5-4,6-4,9.5
			s1.4,7,4,9.5l52.7,52.7c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-29.6-29.6h227.3c28.6,0,51.9-23.3,51.9-51.9
			v-278.5C473.587,75.875,450.287,52.675,421.687,52.675z"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};
export const PoolPlay = ({ type, width, height, color, style }) => {
  return (
    <svg
      id="Calque_1"
      data-name="Calque 1"
      viewBox="0 0 2318.88 1454.28"
      width={width}
      height={height}
      style={style}
    >
      <g fill={color}>
        <path
          className="cls-1"
          d="M2437.54,1820.86c-67.87,38.34-141.51,54.78-213.34,25-109.78-45.54-218.12-60-335.4-15.83-5.19-38.54-10-73.48-14.58-108.46-4.3-32.79-6.91-65.91-13.35-98.28-2.15-10.8-11.74-23.93-21.52-28.82-161.38-80.7-287.07-202-393.44-345-31.54-42.39-60.21-87.13-87.49-132.42-28.85-47.93-22.21-84.37,16.06-111.85,38.75-27.83,82.59-23.68,117.33,15,68.21,76,137.2,150.91,219.92,211.73,75.52,55.52,157.07,98,250.26,114.92,139.7,25.32,265.64-4.32,375.26-96.06,114.65-96,188.35-220.34,244.86-356.38q7.62-18.33,14.36-37c23.51-65,94.23-63.16,131.92-39,22.18,14.22,32.83,35.49,28.56,61.1-6.3,37.72-13.3,75.55-23.6,112.33-55.66,198.82-149.34,375.74-303.8,516.4-15.81,14.4-13.94,29.45-12.35,46.64q10.4,112.7,20.18,225.46C2438.49,1793.35,2437.54,1806.55,2437.54,1820.86Z"
          transform="translate(-1340.56 -772.86)"
        />
        <path
          className="cls-1"
          d="M3199,1812.39c-9.84-.79-16.26-.73-22.45-1.89-81.28-15.28-160.42-10.81-236.86,23.61-66.83,30.09-134.72,33.26-208,5.47,3.44-48.88,6.52-97.25,10.35-145.56,2.82-35.59,5.34-71.3,10.49-106.59,2.64-18-3.29-28.93-15.08-41.68q-55.11-59.57-106.67-122.36c-6-7.23-9.34-23.77-5.19-31,30.8-53.66,63.82-106.06,98.13-162.12,9.88,11.17,19.39,21.6,28.55,32.33,57,66.69,124.2,119.11,209.08,144.9,111.1,33.75,214.57,8,312.93-45.76,94.05-51.44,172-122.56,241.35-203.54,9.39-11,19-22.39,30.46-30.84,29.51-21.69,64.87-19.41,91.05,4,24.94,22.31,29.65,47.35,10.38,82.23a1078.25,1078.25,0,0,1-217.79,276c-54.89,50.18-113.48,95.62-181.12,127.33-21.15,9.91-28.79,23.53-31,45.22C3212.46,1711.82,3205.48,1761.29,3199,1812.39Z"
          transform="translate(-1340.56 -772.86)"
        />
        <path
          className="cls-1"
          d="M2329.29,1032.6c-.48,143.45-114.31,257.24-257.47,257.37-144.4.13-261-116.13-260.23-259.52.76-143.79,117.64-258.51,262.42-257.58C2216.22,773.78,2329.76,889.3,2329.29,1032.6Z"
          transform="translate(-1340.56 -772.86)"
        />
        <path
          className="cls-1"
          d="M2826.52,1150.73c-.74-121.64,93.16-218.54,213.17-220,122.89-1.47,221.49,93.73,222.88,215.18,1.35,118.55-96.47,219.62-214.06,221.14C2926.5,1368.67,2827.25,1271.94,2826.52,1150.73Z"
          transform="translate(-1340.56 -772.86)"
        />
        <path
          className="cls-1"
          d="M2033.05,1881c52,3.08,100.82,13.08,147.41,34.12,79.27,35.8,158.43,35.89,238.26,1,98.79-43.21,197.63-42,296.3,1.68,74,32.76,149.22,33.91,223.29,1.45,102.84-45.09,204.27-45.3,307.76-1.09,30.87,13.19,66.27,15.81,99.62,23.16,2.53.56,5.3,0,7.92.27,26.13,3,41,17.53,40.54,39.64-.44,22.47-15.13,37.5-41.83,38.2-48.34,1.26-94.57-9.69-138.62-29.47-39.17-17.59-79.87-30.72-123-25.54-36.32,4.36-74.28,8.62-107.55,22.46-103.63,43.12-205.17,44.29-308-.75-74.24-32.53-149.26-31.57-223.33.95q-150.21,66-300.16.62c-77.05-33.5-153.48-31.87-231.27-.39-34,13.75-70.56,21.39-106.4,30-13.88,3.33-29.13,3.27-43.45,1.84-22.87-2.29-38-19.1-36.66-39.46,1.43-21.14,14-37.61,34.53-36.85,58,2.16,107.57-23.89,160.24-40.77C1962.3,1891.32,1998.19,1887.81,2033.05,1881Z"
          transform="translate(-1340.56 -772.86)"
        />
        <path
          className="cls-1"
          d="M2109.42,2098.11a312.31,312.31,0,0,1,127.35,28.09c66.41,29.92,132.81,30.35,199.7,1,84.39-37,169.32-37.91,253.91-.77,69.61,30.56,137.82,28.55,207.28-2.1,76.1-33.58,154.51-33.51,231.94-4.35,37.29,14,73.43,28.66,114.41,29.06,26.08.26,40.18,17.67,39.11,40.31s-16,39.2-42.86,36.06c-40.24-4.71-81.88-10.48-119.06-25.43-67.81-27.25-133.11-30.19-200-1.05-87.28,38.05-174.49,37.37-261.47-1-64.28-28.37-128.66-27-192.35.86q-129.1,56.45-257.79.64c-65.75-28.56-130.11-27.51-196.4-1.21-31.61,12.53-65.68,19.15-99,26.91-11.28,2.63-23.91,2.07-35.5.27-20.91-3.26-33.35-17-33.57-38-.2-19.26,11.75-36.87,29.83-36.54,60.57,1.13,111.55-30.93,167.89-43.52C2064.65,2102.43,2087.21,2101.07,2109.42,2098.11Z"
          transform="translate(-1340.56 -772.86)"
        />
      </g>
    </svg>
  );
};
export const SetSchedule = ({ type, width, height, color, style }) => {
  return (
    <svg
      version="1.1"
      viewBox="0 0 35 32"
      width={width}
      height={height}
      style={style}
    >
      <g fill={color}>
        <path
          d="M4,4v24h24V4H4z M6,10h5v4H6V10z M19,14h-6v-4h6V14z M19,16v4h-6v-4H19z M6,16h5v4H6V16z M6,26v-4h5
	v4H6z M13,26v-4h6v4H13z M26,26h-5v-4h5V26z M26,20h-5v-4h5V20z M26,14h-5v-4h5V14z M6,8V6h20v2H6z"
        />
      </g>
    </svg>
  );
};

export const Ladder = ({ type, width, height, color, style }) => {
  return (
    <>
      <svg
        version="1.1"
        viewBox="0 0 1200 1000"
        width={width}
        height={height}
        style={style}
      >
      <g fill={color}>
        <path d="m643.12 790.84h117.55l-30.961 115.68h-117.62zm133.68-498.51h117.48l-30.973 115.68h-117.55zm5.0664-146.8c-11.027 0.64062-20.426 8.332-23.121 19.039l-87.707 327.46 42.719 35.348 18.465-68.961h117.56l-31.039 115.84h-51.387c12.852 16.801 16.32 31.734 14.734 50.387h23.105l-30.961 115.76h-117.57l21.238-79.441-42.293-36.785-106.38 397.12c-10.961 33.68 41.32 47.719 48.602 12.973l20.773-77.348h117.57l-17.227 64.375c-8.6914 32.492 40.066 45.492 48.668 12.973l229.57-856.66c4.7188-16.602-8.3477-32.973-25.613-32.094-11.039 0.64062-20.348 8.332-23.055 19.039l-20.691 77.348h-117.57l17.227-64.293c4.7227-16.598-8.3438-32.973-25.625-32.09z" />
        <path d="m567.17 249.13c-15.293 0.28125-27.508 12.922-27.238 28.199l0.77344 66.879-77 24.668-62.293 16.719c-2.5586 0.67969-5.0664 1.7344-7.3594 3.1211l-77.961 51.039-66.465-1.2383c-37.707-0.69141-37.707 56.238 0 55.559l74.309 1.3086c5.0547 0 10.133-1.4531 14.52-4.0938l53.602-36.121 52.227 132.15c1.8672 4.6016 4.707 8.6797 8.3867 11.945l66.586 65.547-15.625 78.199c-8.4648 42.559 53.828 55.895 61.602 13.266l19.16-105.75c0-9.1055-3.8008-17.852-10.535-24.039l-55.48-55.199 109.84 6.7852 71.172 62.094c34.227 28.68 76.16-24.508 40.215-51.105l-79.375-68.547c-5.2812-4.1602-11.668-6.6016-18.332-6.9453l-100.13-6.2383-38.055-92.988 73.254-23.465c11.465-3.7461 19.254-14.441 19.254-26.441l-0.85938-87.109c0.25391-15.613-12.492-28.387-28.188-28.199z" />
        <path
          d="m444.6 227.35c30.559 18.762 40.066 58.613 21.309 89.172-18.734 30.398-58.652 39.922-89.148 21.16-30.492-18.746-40.078-58.613-21.32-89.012 18.746-30.574 58.664-40.066 89.16-21.32z"
          fill-rule="evenodd"
        />
        </g>
      </svg>
    </>
  );
}

export function SVGIcon(data, SetEventColor) {
  let svg = (
    <SingleElim
      color={SetEventColor(99)}
      style={{ marginRight: -6 }}
      width="30px"
      height="30px"
    />
  );
  switch (data.format) {
    case "Double Elimination":
      svg = (
        <DoubleElim
          color={SetEventColor(99)}
          style={{ marginRight: -6 }}
          width="30px"
          height="30px"
        />
      );
      break;
    case "Round Robin":
      svg = (
        <RoundRobin
          color={SetEventColor(99)}
          style={{ marginRight: 4 }}
          width="20px"
          height="20px"
        />
      );
      break;
    case "Pool Play":
      svg = (
        <PoolPlay
          color={SetEventColor(99)}
          style={{ marginRight: 4 }}
          width="30px"
          height="30px"
        />
      );
      break;
    case "Set Schedule":
      svg = (
        <SetSchedule color={SetEventColor(99)} width="30px" height="25px" />
      );
      break;
    case "Ladder":
      svg = <Ladder color={SetEventColor(99)} width="30px" height="30px" />;
      break;
    default:
      break;
  }
  return svg;
}
